import React, { useEffect, useState, useMemo } from "react";

import { IonIcon } from "@ionic/react";
import { chevronBackOutline, helpCircleOutline, trash } from "ionicons/icons";

import {
  Tooltip,
  Spin,
  Radio,
  Typography,
  Table,
  Input,
  Avatar,
  Collapse,
  Row,
  Col,
  Button,
  Modal,
  Image,
  Upload,
  Space,
  Checkbox,
  Divider,
  Switch,
  Tabs,
  Progress,
  Statistic,
  AutoComplete,
  Popover,
} from "antd";
import {
  CaretRightOutlined,
  EditFilled,
  UploadOutlined,
  CloseCircleTwoTone,
  DownloadOutlined,
  PlusOutlined,
  MailOutlined,
  UserOutlined,
} from "@ant-design/icons";

import { v4 as uuidv4 } from "uuid";
import moment from "moment-timezone";
import axios from "axios";
import https from "https";
import c from "../../../utils/common";
import { useTranslation } from "react-i18next";
import produce from "immer";
import deepcopy from "deepcopy";
import ImgCrop from "antd-img-crop";
import csvUtil from "../../../utils/csv";
import validator from "validator";
import metaData from "../../../data/metaData";
import log from "../../../utils/log";

/* Global State*/

import { style } from "../../../css/css";
import useAuthStore from "../../../states/useAuth";
import { showErrMsg } from "../../../utils/error";
import useShop from "../../../hooks/useShop";
import usePromotionCodeQuery from "../../../hooks/useQuery/usePromotionCode";
import ShopLogo from "../../../components/Shop/Logo";

const { Panel } = Collapse;
const { Paragraph } = Typography;
const { Search } = Input;
const CheckboxGroup = Checkbox.Group;
const { TabPane } = Tabs;
let globalState = undefined;

const title_max_word_count = 50;
const body_max_word_count = 200;

const sample_csv_config = {
  fileName: "sample",
  csvData: [
    {
      tel: "1234567890",
    },
    {
      tel: "1234567891",
    },
    {
      tel: "1234567892",
    },
    {
      tel: "1234567893",
    },
  ],
};

const PushNotification = () => {
  const { auth } = useAuthStore();
  const { getShops } = useShop();
  const { t, i18n } = useTranslation();
  const now = useMemo(() => moment().toISOString(), []);

  const [is_loading_templates, set_is_loading_templates] = useState(false);
  const [original_templates, set_original_templates] = useState([]);
  const [templates, set_templates] = useState([]);
  const [active_template_id, set_active_template_id] = useState();

  const [is_loading_delivery_log, set_is_loading_delivery_log] = useState(false);
  const [delivery_logs, set_delivery_logs] = useState([]);

  const [is_loading_single_delivery_log, set_is_loading_single_delivery_log] = useState(false);
  const [active_delivery_log, set_active_delivery_log] = useState();

  const [vendors, set_vendors] = useState([]);
  const [ads, set_ads] = useState([]);

  const [active_tabPane, set_active_tabPane] = useState("template");
  const [is_show_delivery_detail_modal, set_is_show_delivery_detail_modal] = useState(false);
  const [is_submitting, set_is_submitting] = useState(false);
  const [is_creating_new, set_is_creating_new] = useState(false);

  //accordion
  const [accordion_active_key, set_accordion_active_key] = useState(1);

  //step 1
  const [is_image_url_error, set_is_image_url_error] = useState(false);
  const [is_show_test_message_modal, set_is_show_test_message_modal] = useState(false);

  //test message modal
  const [test_targets, set_test_targets] = useState([]);
  const [test_target, set_test_target] = useState();
  const [checked_target_list, set_checked_target_list] = useState([]);
  const [indeterminate, set_indeterminate] = useState(false);
  const [is_check_all, set_is_check_all] = useState(false);

  //step 2
  const [target_input_mode, set_target_input_mode] = useState("xlsx");
  const [is_xlsx_error, set_is_xlsx_error] = useState(false);

  const [target_estimation, set_target_estimation] = useState();
  const [is_loading_target_estimation, set_is_loading_target_estimation] = useState(false);

  const add_blobURL = (str) => {
    return metaData.blobPreURL + "clientUpload-" + str + ".jpeg" + metaData.blobPostURL;
  };
  const remove_blobURL = (str) => {
    return str.replace(`${metaData.blobPreURL}clientUpload-`, "").replace(`.jpeg${metaData.blobPostURL}`, "");
  };

  //step 3
  const [deep_link_options, set_deep_link_options] = useState([
    {
      type: "shop_detail",
      photo: add_blobURL("push_notification_deeplink_option_shop_detail"),
      name: t("pushNotification.text1"),
      url: "/home",
      vendorId: null,
    },
    {
      type: "ad",
      photo: add_blobURL("push_notification_deeplink_option_ad"),
      name: t("pushNotification.text2"),
      url: "/ad/detail",
      id: null,
    },
    {
      type: "estamp",
      photo: add_blobURL("push_notification_deeplink_option_estamp"),
      name: t("pushNotification.text3"),
      url: "/myCoins",
    },
    {
      type: "promotion_code",
      photo: add_blobURL("push_notification_deeplink_option_promotion_code"),
      name: t("pushNotification.text4"),
      code: null,
    },
  ]);

  const [showLogoError1, setShowLogoError1] = useState(false);

  const active_template = useMemo(() => {
    return templates.find((e) => e.id == active_template_id);
  }, [original_templates, templates, active_template_id]);

  const uploadPhotoProps = {
    name: "upload",
    accept: "image/png, image/jpeg",
    maxCount: 1,
    showUploadList: false,
    beforeUpload: (file) => {
      let url = URL.createObjectURL(file);
      console.log(url);
      //
      set_templates(
        produce((draft) => {
          for (let e of draft) {
            if (e.id == active_template_id) {
              e.photo = url;
            }
          }
          return draft;
        })
      );
      return false;
    },
  };

  const upload_xlsx_props = {
    name: "upload",
    listType: "picture-card",
    accept: ".xlsx",
    maxCount: 1,
    showUploadList: false,
    beforeUpload: (file) => {
      //reset error
      set_is_xlsx_error(false);

      const reader = new FileReader();
      reader.onload = async function (event) {
        const fileBinary = event.target.result;
        let result = csvUtil.csvToJSON({ csv: fileBinary });
        console.log(result);
        if (result.status == "Error") {
          //
        } else if (result.status == "Success") {
          set_templates(
            produce((draft) => {
              for (let e of draft) {
                if (e.id == active_template_id) {
                  //remove tel that are not 12 length string
                  let parsed = result.data.map((e) => "+1" + String(e.tel)).filter((e) => e?.length == 12);
                  //remove duplicate tel
                  parsed = [...new Set(parsed)];
                  console.log(parsed);
                  e.targets = parsed;
                  if (parsed.length == 0) {
                    set_is_xlsx_error(true);
                  }
                }
              }
              return draft;
            })
          );
        }
      };
      reader.readAsBinaryString(file);

      return false;
    },
  };

  const template_table_colums = [
    {
      title: t("pushNotification.text5"),
      dataIndex: "title",
      width: 250,
      key: "title",
      ellipsis: true,
      render: (text, record) => (
        <>
          <div style={{ fontWeight: "bold" }}>{record.title}</div>
          <div>{record.body}</div>
        </>
      ),
    },
    {
      title: t("pushNotification.text6"),
      width: 120,
      key: "photo",
      dataIndex: "photo",
      render: (text, record) =>
        record.photo != null ? (
          <img style={{ width: 60, height: 60, objectFit: "cover" }} src={add_blobURL(record.photo)} />
        ) : null,
    },
    {
      title: t("pushNotification.text7"),
      width: 150,
      key: "time",
      dataIndex: "time",
      render: (text, record) =>
        record.time?.last_used != null ? moment(record.time.last_used).format("YYYY-MM-DD HH:mm") : null,
    },
    {
      title: t("pushNotification.text8"),
      width: 125,
      key: "target",
      dataIndex: "target",
      render: (text, record) => (
        <Row>
          {record.target_mode == "all_consumer"
            ? t("pushNotification.text9")
            : `${record.targets?.length || "--"} ${t("pushNotification.text10")}`}
        </Row>
      ),
    },
    {
      title: t("pushNotification.text11"),
      dataIndex: "lastEditBy",
      key: "lastEditBy",
      width: 200,
      ellipsis: true,
      render: (text, record) => <>{render_user_info(record.lastEditBy)}</>,
    },
    {
      title: "Deep Link",
      key: "data",
      dataIndex: "data",
      render: (text, record) => <Row>{render_deep_link_caption(record.data)}</Row>,
    },
    {
      title: "",
      key: "action",
      width: 150,
      render: (text, record) => (
        <Space size="middle">
          <a
            onClick={() => {
              //get data
              get_vendors();
              get_ads();
              get_codes();
              //
              set_templates(
                produce((draft) => {
                  for (let e of draft) {
                    if (e.id == record.id) {
                      e.photo = record.photo == null ? null : add_blobURL(record.photo);
                    }
                  }
                  return draft;
                })
              );
              //
              console.log(templates.find((e) => e.id == record.id));
              set_active_template_id(record.id);
            }}
          >
            {t("reward.Edit")}
          </a>
          <Button
            type="primary"
            shape="round"
            onClick={() => {
              Modal.confirm({
                title: t("pushNotification.text12"),
                //content: "some messages...some messages...",
                onOk: () => {
                  send_push(record.id);
                },
              });
            }}
          >
            {t("pushNotification.text13")}
          </Button>
        </Space>
      ),
    },
  ];

  const delivery_log_table_colums = [
    {
      title: t("pushNotification.text14"),
      width: 125,
      key: "time",
      dataIndex: "time",
      render: (text, record) => (record.time != null ? moment(record.time).format("YYYY-MM-DD HH:mm") : null),
    },
    {
      title: t("pushNotification.text15"),
      width: 75,
      key: "batchId",
      dataIndex: "batchId",
      render: (text, record) => (
        <Paragraph copyable={{ text: record.id }} style={{ margin: 0 }}>
          {record.id}
        </Paragraph>
      ),
    },
    {
      title: t("pushNotification.text16"),
      width: 200,
      key: "title",
      dataIndex: "title",
      ellipsis: true,
      render: (text, record) => (
        <Row align="middle">
          <div style={{ fontWeight: "bold" }}>{record.title}</div>
        </Row>
      ),
    },
    {
      title: "",
      key: "action",
      width: 150,
      render: (text, record) => (
        <Space size="middle">
          <a
            onClick={() => {
              get_single_delivery_log(record.id);
              open_delivery_detail_modal();
            }}
          >
            {t("pushNotification.text17")}
          </a>
        </Space>
      ),
    },
  ];

  const send_push = async (templateId) => {
    set_is_submitting(true);

    let data = { id: templateId };
    console.log(data);

    const res = await axios.post(metaData.serverURL + "pushNoti/template/send", data, {
      headers: { Authorization: auth.jwt },
      httpsAgent: new https.Agent({ keepAlive: true, keepAliveMsecs: 60000 }),
    });
    console.log(res);
    set_is_submitting(false);
    if (res.data.status == "Error") {
      if (res.data.error == "code is not ongoing") {
        c.message({ type: "error", content: t("pushNotification.text18") });
      } else {
        c.message({ type: "error", content: t("pushNotification.text19") });
      }
    } else if (res.data.status == "Success") {
      c.message({ type: "success", content: t("pushNotification.text20") });
      await get_data();
    }
  };

  const send_test_push = async () => {
    set_is_submitting(true);

    let has_new_photo = false;
    let photo_fileName = null;
    let formData = new FormData();

    if (active_template.photo != null) {
      has_new_photo = active_template.photo.indexOf(metaData.blobPreURL) == -1 ? true : false;
      console.log(`has_new_photo: ${has_new_photo}`);

      if (has_new_photo == false) {
        //no blob
        photo_fileName = remove_blobURL(active_template.photo);
      } else {
        let new_photo_blob;

        photo_fileName = uuidv4();
        try {
          new_photo_blob = await fetch(active_template.photo).then((r) => r.blob());
        } catch (error) {
          setShowLogoError1(true);
          set_is_submitting(false);
          return;
        }
        formData.append("photo", new_photo_blob, photo_fileName);
      }
    } else {
      //no blob
      photo_fileName = null;
    }

    let data = {
      title: active_template.title,
      body: active_template.body,
      photo: photo_fileName,
      targets: checked_target_list,
      data: active_template.data,
    };

    console.log(data);
    formData.append("data", JSON.stringify(data));

    const config = {
      headers: {
        "Content-Type": `multipart/form-data; boundary=${formData._boundary}`,
        Authorization: auth.jwt,
        httpsAgent: new https.Agent({ keepAlive: true, keepAliveMsecs: 60000 }),
      },
    };

    const res = await axios.post(metaData.serverURL + "pushNoti/template/send/test", formData, config);
    log.debug(res);
    set_is_submitting(false);
    if (res.data.status == "Error") {
      if (res.data.error == "code is not ongoing") {
        c.message({ type: "error", content: t("pushNotification.text18") });
      } else {
        c.message({ type: "error", content: t("pushNotification.text19") });
      }
    } else if (res.data.status == "Success") {
      c.message({ type: "success", content: t("pushNotification.text20") });
      close_test_message_modal();
    }
  };

  const get_data = async () => {
    get_templates();
    get_delivery_logs();
  };

  const get_vendors = async () => {
    try {
      const res = await getShops();
      log.debug(res);
      let arr = res.filter((e) => e.isPublishByApprover && e.isPublishByMerchant);
      set_vendors(arr);
    } catch (error) {
      log.debug(error);
    }
  };

  const get_ads = async () => {
    try {
      const res = await axios.post(metaData.serverURL + "ad/banners/query", null, {
        headers: { Authorization: auth.jwt },
        httpsAgent: new https.Agent({ keepAlive: true, keepAliveMsecs: 60000 }),
      });
      log.debug(res);
      let arr = res.data.filter((e) => e.isShow == true);
      set_ads(arr);
    } catch (error) {
      log.debug(error);
    }
  };

  const {
    data: codes = [],
    isFetching: isFetchingCodes,
    error: codesError,
    refetch: refetchCodes,
  } = usePromotionCodeQuery("codes", { "time.collect.end": { $gt: now } });

  const get_codes = async () => {
    refetchCodes();
  };

  const get_code_event_status = (event) => {
    //
    if (event.collectTime?.start == null || event.collectTime?.end == null) {
      return null;
    }
    let start = event.collectTime.start;
    let end = event.collectTime.end;
    if (event.isCancelled) {
      return "cancelled";
    }
    if (moment().isBetween(start, end, "days", "[]")) {
      return "ongoing";
    } else if (moment().isBefore(start)) {
      return "pending";
    } else if (moment().isAfter(end)) {
      return "expired";
    }
  };

  const get_templates = () => {
    set_is_loading_templates(true);
    axios
      .get(metaData.serverURL + "pushNoti/template", {
        headers: { Authorization: auth.jwt },
      })
      .then((res) => {
        console.log(res);
        if (res.data.status == "Error") {
          //
        } else if (res.data.status == "Success") {
          let data = res.data.data;
          for (let i = 0; i < data.length; i++) {
            //insert index
            data[i].index = i;
          }
          console.log(data);
          set_original_templates(data);
          set_templates(data);
        }
      })
      .catch((err) => {
        //
      })
      .finally(set_is_loading_templates(false));
  };

  const get_delivery_logs = () => {
    set_is_loading_delivery_log(true);
    axios
      .get(metaData.serverURL + "pushNoti/template/delivery/log", {
        headers: { Authorization: auth.jwt },
      })
      .then((res) => {
        console.log(res);
        if (res.data.status == "Error") {
          //
        } else if (res.data.status == "Success") {
          let data = res.data.data;
          for (let i = 0; i < data.length; i++) {
            //insert index
            data[i].index = i;
          }
          console.log(data);
          set_delivery_logs(data);
          set_is_loading_delivery_log(false);
        }
      })
      .catch((err) => {
        set_is_loading_delivery_log(false);
      });
  };

  const get_single_delivery_log = (id) => {
    set_is_loading_single_delivery_log(true);
    axios
      .get(metaData.serverURL + "pushNoti/template/delivery/log?id=" + id, {
        headers: { Authorization: auth.jwt },
      })
      .then((res) => {
        console.log(res);
        if (res.data.status == "Error") {
          //
        } else if (res.data.status == "Success") {
          let data = res.data.data;
          console.log(data);
          set_active_delivery_log(data);
          set_is_loading_single_delivery_log(false);
        }
      })
      .catch((err) => {
        set_is_loading_single_delivery_log(false);
      });
  };

  const parse_json = (raw) => {
    let data;
    raw = typeof raw === "string" ? raw : JSON.stringify(raw);
    try {
      data = JSON.parse(raw);
    } catch (error) {
      return { status: "Error", error: "try catch" };
    }
    if (typeof data !== "object") {
      return { status: "Error", error: "not a object" };
    }
    return { status: "Success", data };
  };

  const parse_tel_manual_input = (raw) => {
    //parse
    if (Array.isArray(raw)) {
      raw = raw.map((e) => e.replace("+1", ""));
    } else {
      raw = raw.split(",");
    }
    //console.log(raw);

    //validate
    let pass = raw.every((e) => validator.isNumeric(e) && validator.isLength(e, { min: 10, max: 10 }));
    //console.log(pass);
    if (pass) {
      return { status: "Success", data: raw };
    } else {
      return { status: "Error", data: raw };
    }
  };

  const parse_targets_to_string = (data) => {
    if (Array.isArray(data) && data.length > 0) {
      return data
        .map((e) => e.replace("+1", ""))
        .toString()
        .split(",");
    } else {
      return;
    }
  };

  const create_template = async () => {
    set_is_submitting(true);

    //blob
    let photo_fileName;
    let photo_blob;
    const formData = new FormData();

    if (active_template.photo != null) {
      photo_fileName = uuidv4();
      try {
        photo_blob = await fetch(active_template.photo).then((r) => r.blob());
      } catch (error) {
        setShowLogoError1(true);
        set_is_submitting(false);
        return;
      }
      formData.append("photo", photo_blob, photo_fileName);
    }

    let postData = {
      id: active_template.id,
      title: active_template.title,
      body: active_template.body,
      photo: photo_fileName,
      target_mode: active_template.target_mode,
      targets: active_template.target_mode == "all_consumer" ? null : active_template.targets,
      data: active_template.data,
    };

    //checking
    // if (postData.data != null) {
    //   console.log(postData.data);
    //   let parse_result = parse_json(postData.data);
    //   console.log(parse_result);
    //   if (parse_result.status == "Error") {
    //     c.message({ type: "error", key: uuidv4(), content: "deep link資料格式不正確" });
    //     set_is_submitting(false);
    //     return;
    //   } else {
    //     postData.data = parse_result.data;
    //   }
    // }
    if (postData.target_mode == "partial_consumer" && postData.targets != null) {
      let parse_result = parse_tel_manual_input(postData.targets);
      console.log(parse_result);
      if (parse_result.status == "Error") {
        c.message({ type: "error", key: uuidv4(), content: t("pushNotification.text21") });
        set_is_submitting(false);
        return;
      } else {
        //remove duplicate tel
        parse_result.data = [...new Set(parse_result.data)];
        postData.targets = parse_result.data.map((e) => "+1" + e);
      }
    }

    console.log(postData);

    //
    formData.append("data", JSON.stringify(postData));

    const config = {
      headers: {
        "Content-Type": `multipart/form-data; boundary=${formData._boundary}`,
        Authorization: auth.jwt,
        httpsAgent: new https.Agent({ keepAlive: true, keepAliveMsecs: 60000 }),
      },
    };

    const res = await axios.post(metaData.serverURL + "pushNoti/template/create", formData, config);
    console.log(res);
    set_is_submitting(false);
    if (res.data.status == "Error") {
      c.message({ type: "error", content: t("pushNotification.text22") });
    } else if (res.data.status == "Success") {
      c.message({ type: "success", content: t("pushNotification.text23") });
      discard_form();
      await get_data();
    }
  };

  const update_template = async () => {
    set_is_submitting(true);

    let has_new_photo = false;
    let photo_fileName = null;
    let formData = new FormData();

    if (active_template.photo != null) {
      has_new_photo = active_template.photo.indexOf(metaData.blobPreURL) == -1 ? true : false;
      console.log(`has_new_photo: ${has_new_photo}`);

      if (has_new_photo == false) {
        //no blob
        photo_fileName = remove_blobURL(active_template.photo);
      } else {
        let new_photo_blob;

        photo_fileName = uuidv4();
        try {
          new_photo_blob = await fetch(active_template.photo).then((r) => r.blob());
        } catch (error) {
          setShowLogoError1(true);
          set_is_submitting(false);
          return;
        }
        formData.append("photo", new_photo_blob, photo_fileName);
      }
    } else {
      //no blob
      photo_fileName = null;
    }

    let postData = {
      id: active_template.id,
      title: active_template.title,
      body: active_template.body,
      photo: photo_fileName,
      target_mode: active_template.target_mode,
      targets: active_template.target_mode == "all_consumer" ? null : active_template.targets,
      data: active_template.data,
    };

    //checking
    // if (postData.data != null) {
    //   console.log(postData.data);
    //   let parse_result = parse_json(postData.data);
    //   console.log(parse_result);
    //   if (parse_result.status == "Error") {
    //     c.message({ type: "error", key: uuidv4(), content: "deep link資料格式不正確" });
    //     set_is_submitting(false);
    //     return;
    //   } else {
    //     postData.data = parse_result.data;
    //   }
    // }
    if (postData.target_mode == "partial_consumer" && postData.targets != null) {
      let parse_result = parse_tel_manual_input(postData.targets);
      console.log(parse_result);
      if (parse_result.status == "Error") {
        c.message({ type: "error", key: uuidv4(), content: t("pushNotification.text21") });
        set_is_submitting(false);
        return;
      } else {
        //remove duplicate tel
        parse_result.data = [...new Set(parse_result.data)];
        postData.targets = parse_result.data.map((e) => "+1" + e);
      }
    }

    if (postData.data != null) {
    }

    console.log(postData);

    formData.append("data", JSON.stringify(postData));
    console.log(formData);
    const config = {
      headers: {
        "Content-Type": `multipart/form-data; boundary=${formData._boundary}`,
        Authorization: auth.jwt,
        httpsAgent: new https.Agent({ keepAlive: true, keepAliveMsecs: 60000 }),
      },
    };

    const res = await axios.post(metaData.serverURL + "pushNoti/template/update", formData, config);
    console.log(res);
    set_is_submitting(false);
    if (res.data.status == "Error") {
      c.message({ type: "error", content: t("pushNotification.text22") });
    } else if (res.data.status == "Success") {
      c.message({ type: "success", content: t("pushNotification.text23") });
      discard_form();
      await get_data();
    }
  };

  const delete_template = async () => {
    set_is_submitting(true);

    let data = { id: active_template_id };

    const res = await axios.post(metaData.serverURL + "pushNoti/template/delete", data, {
      headers: { Authorization: auth.jwt },
      httpsAgent: new https.Agent({ keepAlive: true, keepAliveMsecs: 60000 }),
    });
    console.log(res);
    set_is_submitting(false);
    if (res.data.status == "Error") {
      c.message({ type: "error", content: t("pushNotification.text22") });
    } else if (res.data.status == "Success") {
      c.message({ type: "success", content: t("pushNotification.text25") });
      discard_form();
      await get_data();
    }
  };

  // const get_target_estimation = async () => {
  //   set_is_loading_target_estimation(true);

  //   let data = {
  //     target_mode: active_template.target_mode,
  //     targets: active_template.target_mode == "all_consumer" ? null : active_template.targets,
  //   };

  //   console.log(data);
  //   return;
  //   const res = await axios.post(metaData.serverURL + "pushNoti/template/estimate", data, {
  //     headers: { Authorization: auth.jwt },
  //   });
  //   console.log(res);
  //   set_is_loading_target_estimation(false);

  //   if (res.data.status == "Error") {
  //     set_target_estimation(0);
  //   } else if (res.data.status == "Success") {
  //     set_target_estimation(res.data.data);
  //   }

  //   //set_target_estimation(Math.floor(Math.random() * 1000));
  // };

  const is_step_valid = (step) => {
    if (step == 1) {
      if (active_template.body == null) {
        return false;
      }
      if (is_image_url_error) {
        return false;
      }
    }

    if (step == 2) {
      if (["all_consumer", "partial_consumer"].includes(active_template.target_mode) == false) {
        return false;
      }
      if (active_template.target_mode == "partial_consumer") {
        if (active_template.targets?.length > 0 == false) {
          return false;
        }
      }
    }

    if (step == 3) {
      if (active_template.data != null) {
        if (active_template.data.type == "shop_detail" && active_template.data.vendorId == null) {
          return false;
        }
        if (active_template.data.type == "ad" && active_template.data.id == null) {
          return false;
        }
        if (active_template.data.type == "promotion_code" && active_template.data.code == null) {
          return false;
        }
      }
    }

    return true;
  };

  const is_form_valid = () => {
    return is_step_valid(1) && is_step_valid(2) && is_step_valid(3);
  };

  const discard_form = () => {
    if (is_creating_new) {
      set_is_creating_new(false);
    }
    //
    set_is_image_url_error(false);
    set_is_xlsx_error(false);
    set_target_estimation();
    set_is_loading_target_estimation(false);
    set_is_loading_templates(false);
    setShowLogoError1(false);
    //
    set_accordion_active_key(1);
    set_active_template_id();
  };

  const reset_form = () => {
    set_templates(original_templates);
  };

  const handle_step_change = (to) => {
    //console.log(to);
    if (is_step_valid(accordion_active_key) == false) {
      //invalid
      return;
    }
    set_accordion_active_key(to);
  };

  const close_test_message_modal = () => {
    set_is_show_test_message_modal(false);
  };

  const open_delivery_detail_modal = () => {
    set_is_show_delivery_detail_modal(true);
  };

  const close_delivery_detail_modal = () => {
    set_is_show_delivery_detail_modal(false);
  };

  /**
   * UI Component
   */
  const render_delivery_detail_modal = () => {
    let total_count = active_delivery_log?.delivery?.total;
    let foreground_count = active_delivery_log?.delivery?.foreground;
    let open_count = active_delivery_log?.delivery?.open;

    const get_delivery_percentage = () => {
      return parseInt(((foreground_count + open_count) / total_count) * 100);
    };

    return (
      <Modal
        title={`${t("pushNotification.text15")} ${active_delivery_log?.id} ${t("pushNotification.text17")}`}
        open={is_show_delivery_detail_modal}
        onOk={() => {
          close_delivery_detail_modal();
        }}
        onCancel={() => close_delivery_detail_modal()}
        bodyStyle={{ padding: 0, height: 500, overflowY: "scroll" }}
        width={850}
        centered
      >
        {is_loading_single_delivery_log ? (
          <Row justify="center" align="middle" style={{ width: "100%", height: "100%" }}>
            <Spin />
          </Row>
        ) : (
          <Row style={{ width: "100%", padding: 25 }}>
            {/* Delivery Detail */}
            <Row justify="space-between" style={{ width: "100%" }}>
              <Col span={11}>
                {/* Left Part */}
                <Row style={{ width: "100%" }}>
                  <Col style={{ width: "100%" }}>
                    <div style={{ fontSize: 15 }}>{t("pushNotification.text26")}</div>
                    <div style={{ fontSize: 25 }}>
                      {foreground_count + open_count} /{total_count}
                    </div>
                    <Progress percent={get_delivery_percentage()} />
                  </Col>
                </Row>
              </Col>
              <Col span={11}>
                {/* Right Part */}
                <Row>
                  <div style={{ marginLeft: 12 }}>{t("pushNotification.text27")}</div>
                  <Row align="middle" style={{ width: "100%" }}>
                    <Statistic style={{ margin: 12 }} title={t("pushNotification.text28")} value={foreground_count} />
                    <Statistic style={{ margin: 12 }} title={t("pushNotification.text29")} value={open_count} />
                  </Row>
                </Row>
              </Col>
            </Row>

            <Divider />
            {/* Notification */}
            <Row style={{ width: "100%" }}>
              <div style={{ fontWeight: "bold", width: "100%" }}>{t("pushNotification.text30")}</div>
              <div style={{ width: "100%", marginBottom: 25 }}>{render_user_info(active_delivery_log?.sentBy)}</div>

              <div style={{ fontWeight: "bold", width: "100%" }}>{t("pushNotification.text14")}:</div>
              <div style={{ width: "100%", marginBottom: 25 }}>
                {moment(active_delivery_log?.time).format("YYYY-MM-DD HH:mm")}
              </div>

              <div style={{ fontWeight: "bold", width: "100%" }}>{t("pushNotification.text16")}:</div>
              <div style={{ width: "100%", marginBottom: 25 }}>{active_delivery_log?.title}</div>

              <div style={{ fontWeight: "bold", width: "100%" }}>{t("pushNotification.text31")}</div>
              <div style={{ width: "100%", marginBottom: 25 }}>{active_delivery_log?.body}</div>

              <div style={{ fontWeight: "bold", width: "100%" }}>{t("pushNotification.text6")}</div>
              {active_delivery_log?.photo == null ? (
                t("pushNotification.text47")
              ) : (
                <img
                  style={{ width: 70, height: 70, objectFit: "cover" }}
                  src={add_blobURL(active_delivery_log?.photo)}
                />
              )}

              <div style={{ fontWeight: "bold", width: "100%", marginTop: 25 }}>{t("pushNotification.text8")}:</div>
              <div style={{ width: "100%", marginBottom: 25 }}>
                {active_delivery_log?.target_mode == "all_consumer" ? (
                  t("pushNotification.text9")
                ) : (
                  <div>
                    {active_delivery_log?.targets?.length || "--"} {t("pushNotification.text10")}
                    <Button
                      type="primary"
                      size="small"
                      style={{ marginLeft: 25 }}
                      //disabled={active_template.targets?.length > 0 == false}
                      onClick={() => {
                        csvUtil.exportToCSV({
                          fileName: "tel_list",
                          csvData: active_delivery_log?.targets.map((e) => {
                            return {
                              tel: e.replace("+1", ""),
                            };
                          }),
                        });
                      }}
                      icon={<DownloadOutlined />}
                    >
                      {t("pushNotification.text32")}
                    </Button>
                  </div>
                )}
              </div>

              <div style={{ fontWeight: "bold", width: "100%" }}>Deeplink:</div>
              <div style={{ width: "100%", marginBottom: 10 }}>
                {active_delivery_log?.data?.type == null
                  ? t("pushNotification.text47")
                  : render_deep_link_caption(active_delivery_log?.data)}
              </div>
            </Row>
          </Row>
        )}
      </Modal>
    );
  };

  const render_deeplink_vendor_search_bar = () => {
    //filter out id that exist on related_vendors
    const get_search_list = () => {
      return vendors.map((e) => {
        return {
          label: (
            <div>
              <ShopLogo style={{ width: 45, height: 45 }} logo={e?.logo} brandLogo={e?.brand?.logo} />
              {e.name}
            </div>
          ),
          value: e.name, //for search matching
          vendorId: e.id, //for onSelect
        };
      });
    };

    const get_search_bar_default_value = () => {
      return vendors?.find((e) => e.id == active_template?.data?.vendorId)?.name;
    };

    return (
      <Row>
        <span style={{ fontWeight: "bold" }}>{t("pushNotification.text33")}:</span>
        <AutoComplete
          style={{ width: "100%", border: "5px solid #f0f2f5", position: "sticky", zIndex: 1, top: 0 }}
          size="large"
          allowClear
          options={get_search_list()}
          placeholder={t("pushNotification.text34")}
          defaultValue={get_search_bar_default_value()}
          onChange={(value, option) => {
            //console.log({ value, option });
            //set vendorId to null
            set_templates(
              produce((draft) => {
                for (let e of draft) {
                  if (e.id == active_template_id) {
                    e.data.url = "/home";
                    e.data.vendorId = null;
                  }
                }
                return draft;
              })
            );
          }}
          onSelect={(value, option) => {
            console.log({ value, option });
            let selectedId = option?.vendorId;
            set_templates(
              produce((draft) => {
                for (let e of draft) {
                  if (e.id == active_template_id) {
                    e.data.url = "/shop/" + selectedId;
                    e.data.vendorId = selectedId;
                  }
                }
                return draft;
              })
            );
          }}
          filterOption={(inputValue, option) => option?.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1}
        />
      </Row>
    );
  };

  const render_deeplink_ad_search_bar = () => {
    const get_search_list = () => {
      return ads.map((e) => {
        return {
          label: (
            <div>
              <img
                width={80}
                height={45}
                //src="https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png"
                src={add_blobURL(e.coverPhoto)}
              />
              {e.name}
            </div>
          ),
          value: e.name, //for search matching
          id: e.id, //for onSelect
        };
      });
    };

    const get_search_bar_default_value = () => {
      return ads?.find((e) => e.id == active_template?.data?.id)?.name;
    };

    return (
      <Row>
        <span style={{ fontWeight: "bold" }}>{t("pushNotification.text35")}:</span>
        <AutoComplete
          style={{ width: "100%", border: "5px solid #f0f2f5", position: "sticky", zIndex: 1, top: 0 }}
          size="large"
          allowClear
          options={get_search_list()}
          placeholder={t("pushNotification.text36")}
          defaultValue={get_search_bar_default_value()}
          onChange={(value, option) => {
            //console.log({ value, option });
            //set vendorId to null
            set_templates(
              produce((draft) => {
                for (let e of draft) {
                  if (e.id == active_template_id) {
                    e.data.id = null;
                  }
                }
                return draft;
              })
            );
          }}
          onSelect={(value, option) => {
            console.log({ value, option });
            let selectedId = option?.id;
            set_templates(
              produce((draft) => {
                for (let e of draft) {
                  if (e.id == active_template_id) {
                    e.data.id = selectedId;
                  }
                }
                return draft;
              })
            );
          }}
          filterOption={(inputValue, option) => option?.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1}
        />
      </Row>
    );
  };

  const render_deeplink_promotion_code_search_bar = () => {
    const get_search_list = () => {
      return codes.map((e) => {
        return {
          label: <div>{e.code}</div>,
          value: e.code, //for search matching
          id: e.code, //for onSelect
        };
      });
    };

    const get_search_bar_default_value = () => {
      return codes?.find((e) => e.id == active_template?.data?.id)?.code;
    };

    return (
      <Row>
        <span style={{ fontWeight: "bold" }}>{t("pushNotification.text37")}:</span>
        <AutoComplete
          style={{ width: "100%", border: "5px solid #f0f2f5", position: "sticky", zIndex: 1, top: 0 }}
          size="large"
          allowClear
          options={get_search_list()}
          placeholder={t("pushNotification.text38")}
          defaultValue={get_search_bar_default_value()}
          onChange={(value, option) => {
            //console.log({ value, option });
            //set vendorId to null
            set_templates(
              produce((draft) => {
                for (let e of draft) {
                  if (e.id == active_template_id) {
                    e.data.code = null;
                  }
                }
                return draft;
              })
            );
          }}
          onSelect={(value, option) => {
            console.log({ value, option });
            let selectedId = option?.id;
            set_templates(
              produce((draft) => {
                for (let e of draft) {
                  if (e.id == active_template_id) {
                    e.data.code = selectedId;
                  }
                }
                return draft;
              })
            );
          }}
          filterOption={(inputValue, option) => option?.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1}
        />
      </Row>
    );
  };

  const render_user_info = (user) => {
    if (user == null) {
      return <div>--</div>;
    } else {
      return (
        <Popover
          content={
            <div>
              <p>
                <MailOutlined style={{ marginRight: 12 }} />
                {user.email}
              </p>
            </div>
          }
          title={
            <Row justify="start" align="middle">
              {user.avatar == null || user.avatar == "" ? (
                <Avatar icon={<UserOutlined />} size={45} style={{ marginRight: 10 }} />
              ) : (
                <Avatar
                  src={metaData.blobPreURL + "clientUpload-" + user.avatar + ".jpeg" + metaData.blobPostURL}
                  size={45}
                  style={{ marginRight: 10 }}
                />
              )}
              {render_user_name(user.nickname) + " " + render_user_name(user.name)}
            </Row>
          }
          trigger="hover"
        >
          <a>{user.email}</a>
        </Popover>
      );
    }
  };

  const render_user_name = (name) => {
    return name != null ? name : "";
  };

  const render_photo_error_msg = () => {
    return (
      <Modal
        centered
        open={showLogoError1}
        onOk={() => {
          setShowLogoError1(false);
        }}
        onCancel={() => {
          setShowLogoError1(false);
        }}
        footer={null}
      >
        <Row align="middle" style={{ marginRight: 20 }}>
          <Col span={4}>
            <CloseCircleTwoTone style={{ fontSize: 40 }} twoToneColor="#F24621" />
          </Col>
          <Col span={20}>
            <strong style={{ fontSize: 20 }}>{t("edit.LogoError")}</strong>
          </Col>
        </Row>
      </Modal>
    );
  };

  const render_test_message_modal = () => {
    const handle_checkbox_change = (list) => {
      set_checked_target_list(list);
      //console.log(list);
      set_indeterminate(!!list.length && list.length < test_targets?.length);
      set_is_check_all(list.length === test_targets.length);
    };
    const handle_checkall_change = (e) => {
      set_checked_target_list(e.target.checked ? deepcopy(test_targets) : []);
      //console.log(e.target.checked ? deepcopy(test_targets) : []);
      set_indeterminate(false);
      set_is_check_all(e.target.checked);
    };

    return (
      <Modal
        title={t("pushNotification.text39")}
        open={is_show_test_message_modal}
        footer={[
          <Button
            key="cancel"
            disabled={is_submitting}
            onClick={() => {
              close_test_message_modal();
            }}
          >
            {t("ticket.Cancel")}
          </Button>,
          <Button
            key="add"
            disabled={is_submitting || checked_target_list.length == 0}
            onClick={() => {
              send_test_push();
            }}
            type="primary"
          >
            {t("pushNotification.text13")}
          </Button>,
        ]}
        onCancel={() => {
          close_test_message_modal();
        }}
        bodyStyle={{ padding: 30, overflowY: "scroll" }}
        width={500}
        centered
        //maskClosable={false}
      >
        <Row style={{ width: "100%" }}>
          {t("pushNotification.text40")}
          <Tooltip title={t("pushNotification.text41")}>
            <IonIcon icon={helpCircleOutline} style={{ marginLeft: 10, fontSize: 18 }} />
          </Tooltip>
          <Row style={{ width: "100%" }}>
            <Col span={20}>
              <Input
                prefix="+1"
                placeholder={t("pushNotification.text42")}
                size="large"
                style={{ marginBottom: 35 }}
                value={test_target}
                maxLength={10}
                onChange={(e) => {
                  let value = e.target.value == "" ? null : e.target.value;
                  //console.log(value)
                  set_test_target(value);
                }}
              />
            </Col>
            <Col span={4}>
              <Button
                type="primary"
                size="large"
                disabled={(test_target?.length == 10) == false}
                onClick={() => {
                  let value = "+1" + test_target;
                  //console.log([...test_targets, value]);
                  //checking
                  if (validator.isNumeric(test_target) && validator.isLength(test_target, { min: 10, max: 10 })) {
                    //pass
                  } else {
                    //is not eight digit, fail
                    c.message({ type: "error", content: t("pushNotification.text42") });
                    return;
                  }

                  if (test_targets.includes(value)) {
                    //already exist
                    c.message({ type: "error", content: t("pushNotification.text43") });
                  } else {
                    set_test_targets([...test_targets, value]);
                    set_test_target();
                    //update check all box
                    set_indeterminate(
                      !!checked_target_list.length && checked_target_list.length < test_targets?.length
                    );
                    set_is_check_all(false);
                  }
                }}
              >
                {t("pushNotification.text44")}
              </Button>
            </Col>
          </Row>
          <Row justify="space-between" style={{ width: "100%" }}>
            <Col>{t("pushNotification.text45")}</Col>
            <Col>
              <Checkbox indeterminate={indeterminate} onChange={handle_checkall_change} checked={is_check_all}>
                {t("pushNotification.text46")}
              </Checkbox>
            </Col>
          </Row>
          <Row style={{ width: "100%" }}>
            <Divider style={{ margin: 5 }} />
            <CheckboxGroup onChange={handle_checkbox_change} value={checked_target_list} style={{ width: "100%" }}>
              <Row>
                {test_targets.map((value, i) => (
                  <Col key={i} span={24} style={{ marginBottom: 10 }}>
                    <Row justify="space-between" align="middle" style={{ width: "100%" }}>
                      <Col span={21}>
                        <Checkbox value={value} style={{ width: "100%" }}>
                          {value}
                        </Checkbox>
                      </Col>
                      <Col span={3}>
                        <Button
                          type="text"
                          shape="round"
                          size="large"
                          onClick={() => {
                            //remove
                            set_test_targets(test_targets.filter((e) => e != value));
                          }}
                          style={{ textAlign: "center" }}
                        >
                          <IonIcon icon={trash} />
                        </Button>
                      </Col>
                    </Row>
                  </Col>
                ))}
              </Row>
            </CheckboxGroup>
          </Row>
        </Row>
      </Modal>
    );
  };

  const render_deep_link_caption = (data) => {
    let text;
    if (data?.type == null) {
      text = t("pushNotification.text47");
    } else if (data?.type == "shop_detail") {
      text = t("pushNotification.text1");
    } else if (data?.type == "estamp") {
      text = t("pushNotification.text3");
    } else if (data?.type == "promotion_code") {
      text = t("pushNotification.text4");
    } else if (data?.type == "ad") {
      text = t("pushNotification.text2");
    }
    return text;
  };

  const render_accordion = () => {
    return (
      <Collapse
        accordion
        activeKey={accordion_active_key}
        style={{ width: "100%" }}
        onChange={(active) => {
          if (active != null) {
            handle_step_change(active);
          }
        }}
        expandIcon={({ isActive }) => {
          return isActive ? (
            <Avatar style={{ backgroundColor: "#1890FF" }} icon={<EditFilled style={{ fontSize: 14 }} />}></Avatar>
          ) : (
            <Avatar style={{}} icon={<CaretRightOutlined />}></Avatar>
          );
        }}
      >
        {render_content_panel()}
        {render_target_panel()}
        {render_deep_link_panel()}
        {/* {render_other_panel()} */}
      </Collapse>
    );
  };

  const render_content_panel = () => {
    return (
      <Panel header={t("pushNotification.text48")} key={1}>
        <Row gutter={20} style={{ width: "100%" }}>
          <Col span={12}>
            {render_notification_title(active_template)}
            {render_notification_body(active_template)}
            {render_photo_picker(active_template)}
            <Button
              type="primary"
              shape="round"
              disabled={is_step_valid(1) == false}
              onClick={() => {
                handle_step_change(2);
              }}
            >
              {t("pushNotification.text49")}
            </Button>
          </Col>
          <Col span={12}>{render_notification_preview(active_template)}</Col>
        </Row>
      </Panel>
    );
  };

  const render_notification_title = (item) => {
    return (
      <Row style={{ width: "100%", fontSize: 16 }}>
        <span style={{ fontWeight: "bold" }}>{t("pushNotification.text16")}</span>
        <Input.TextArea
          showCount
          style={{ width: "100%", fontSize: style.inputFontSize }}
          autoSize={{ minRows: 1 }}
          maxLength={title_max_word_count}
          value={item.title}
          onChange={(e) => {
            let value = e.target.value == "" ? null : e.target.value;
            //console.log(value);
            set_templates(
              produce((draft) => {
                for (let e of draft) {
                  if (e.id == active_template_id) {
                    e.title = value;
                  }
                }
                return draft;
              })
            );
          }}
        />
      </Row>
    );
  };

  const render_notification_body = (item) => {
    return (
      <Row style={{ width: "100%", fontSize: 16 }}>
        <span style={{ fontWeight: "bold" }}>{t("pushNotification.text31")}</span>
        <Input.TextArea
          showCount
          style={{ width: "100%", fontSize: style.inputFontSize }}
          autoSize={{ minRows: 2 }}
          maxLength={body_max_word_count}
          value={item.body}
          onChange={(e) => {
            let value = e.target.value == "" ? null : e.target.value;
            //console.log(value);
            set_templates(
              produce((draft) => {
                for (let e of draft) {
                  if (e.id == active_template_id) {
                    e.body = value;
                  }
                }
                return draft;
              })
            );
          }}
        />
      </Row>
    );
  };

  const render_photo_upload_btn = () => {
    return (
      <ImgCrop grid aspect={1} quality={1}>
        <Upload {...uploadPhotoProps}>
          <Button type="primary" icon={<UploadOutlined />}>
            {t("pushNotification.text50")}
          </Button>
        </Upload>
      </ImgCrop>
    );
  };

  const render_photo_picker = (item) => {
    return (
      <Row style={{ width: "100%", fontSize: 16, marginBottom: 25 }}>
        <span style={{ fontWeight: "bold" }}>
          {t("pushNotification.text6")}
          <Tooltip title={t("pushNotification.text51")}>
            <IonIcon icon={helpCircleOutline} style={{ marginLeft: 10, fontSize: 18 }} />
          </Tooltip>
        </span>
        <Row style={{ width: "100%" }}>
          {/* <Col span={20}>
            <Input
              placeholder="範例: https://yourapp.com/image.png"
              size="large"
              value={item.photo || null}
              onChange={(e) => {
                set_is_image_url_error(false);
                //
                let value = e.target.value == "" ? null : e.target.value;
                set_templates(
                  produce((draft) => {
                    for (let e of draft) {
                      if (e.id == item.id) {
                        e.photo = value;
                      }
                    }
                    return draft;
                  })
                );
              }}
            />
          </Col> */}
          <Col span={4}>
            {/* <Button type="primary" block icon={<UploadOutlined />}></Button> */}
            {render_photo_upload_btn()}
          </Col>
        </Row>
        {is_image_url_error ? <Row style={{ color: "red" }}>{t("pushNotification.text52")}</Row> : null}
      </Row>
    );
  };

  const render_notification_preview = (item) => {
    return (
      <Row style={{ width: "100%", border: "1px solid #DADADA", borderRadius: 5 }}>
        {/* Test Message */}
        <Row style={{ width: "100%", padding: 10 }}>
          <Button
            type="primary"
            shape="round"
            disabled={is_step_valid(1) == false}
            onClick={() => {
              set_is_show_test_message_modal(true);
            }}
          >
            {t("pushNotification.text53")}
          </Button>
        </Row>
        {/* Preview */}
        <Row justify="center" style={{ width: "100%", background: style.gray1, padding: 10 }}>
          <Row justify="start" style={{ width: "100%", marginBottom: 25, fontSize: 16, fontWeight: "bolder" }}>
            {t("pushNotification.text54")}
          </Row>
          {render_mobile_container("android", item)}
          {render_mobile_container("ios", item)}
        </Row>
      </Row>
    );
  };

  const render_mobile_container = (platform, item) => {
    return (
      <>
        <div style={{ position: "relative", width: 300, height: 150 }}>
          <img
            src={
              platform == "android"
                ? "https://www.gstatic.com/mobilesdk/190403_mobilesdk/android.png"
                : "https://www.gstatic.com/mobilesdk/190403_mobilesdk/iphone.png"
            }
          />
          <Row
            style={{
              position: "absolute",
              bottom: "0",
              left: "50%",
              transform: "translateX(-50%)",
              width: 255,
              height: platform == "android" ? 65 : 75,
              backgroundColor: "white",
              borderRadius: platform == "android" ? 0 : 10,
              color: "black",
              padding: 5,
              fontSize: "14px",
              marginBottom: 25,
              overflow: "hidden",
            }}
          >
            <Col span={platform == "android" ? 20 : 24} style={{ padding: 2.5 }}>
              <Paragraph
                style={{
                  width: "100%",
                  fontWeight: "bold",
                  fontSize: 12,
                  textAlign: "start",
                  margin: 0,
                }}
                ellipsis={{
                  rows: 1,
                }}
              >
                {item.title}
              </Paragraph>

              <Paragraph
                style={{
                  width: "100%",
                  fontSize: 12,
                  textAlign: "start",
                  margin: 0,
                }}
                ellipsis={{
                  rows: platform == "android" ? 1 : 2,
                }}
              >
                {item.body}
              </Paragraph>
            </Col>
            {platform == "android" ? (
              <Col span={4} style={{}}>
                <Image
                  preview={false}
                  style={{ width: 45, height: 45, objectFit: "cover" }}
                  src={
                    item.photo == null
                      ? "https://www.gstatic.com/mobilesdk/180130_mobilesdk/images/image_placeholder.png"
                      : item.photo
                  }
                  onError={() => {
                    set_is_image_url_error(true);
                  }}
                />
              </Col>
            ) : null}
          </Row>
        </div>
        <Row justify="center" style={{ width: "100%", marginBottom: 25 }}>
          {platform == "android" ? "Android" : "Apple"}
        </Row>
      </>
    );
  };

  const render_target_panel = () => {
    return (
      <Panel header={t("pushNotification.text55")} key={2}>
        {render_target_mode_radio_group(active_template)}
        {active_template.target_mode == "partial_consumer" ? (
          <>
            {render_input_mode_radio_group(active_template)}

            {target_input_mode == "xlsx" ? (
              <Row justify="space-between" style={{ width: "100%" }}>
                <Col span={12}>
                  <Row style={{ width: "100%", fontSize: 18 }}>
                    <span style={{ fontWeight: "bold" }}>{t("pushNotification.text60")}</span>
                  </Row>

                  <Row style={{ marginBottom: 25 }}>
                    {t("pushNotification.text56")}
                    <span
                      onClick={() => {
                        csvUtil.exportToCSV(sample_csv_config);
                      }}
                      style={{ cursor: "pointer", color: style.blue2 }}
                    >
                      {t("pushNotification.text76")}
                    </span>
                  </Row>

                  {render_xlsx_upload_btn()}
                </Col>
                <Col span={6}>{render_import_count()}</Col>
              </Row>
            ) : (
              <>
                <Row style={{ width: "100%", fontSize: 18 }}>
                  <span style={{ fontWeight: "bold" }}>{t("pushNotification.text57")}</span>
                </Row>

                <Row>{t("pushNotification.text58")}</Row>

                {render_tel_manual_input_error_text()}

                <Input.TextArea
                  style={{ width: "100%", fontSize: style.inputFontSize, marginBottom: 25, marginTop: 25 }}
                  autoSize={{ minRows: 4 }}
                  value={parse_targets_to_string(active_template.targets)}
                  onChange={(e) => {
                    let value = e.target.value == "" ? null : e.target.value;
                    if (value == null) {
                      return;
                    }
                    value = parse_tel_manual_input(value).data;
                    //console.log(value);

                    set_templates(
                      produce((draft) => {
                        for (let e of draft) {
                          if (e.id == active_template_id) {
                            e.targets = value;
                          }
                        }
                        return draft;
                      })
                    );
                  }}
                />
              </>
            )}
          </>
        ) : null}
        {/* {render_estimation()} */}
        <Button
          type="primary"
          shape="round"
          disabled={is_step_valid(2) == false}
          onClick={() => {
            handle_step_change(3);
          }}
        >
          {t("pushNotification.text49")}
        </Button>
      </Panel>
    );
  };

  const render_target_mode_radio_group = (item) => {
    return (
      <Row style={{ width: "100%", marginBottom: 25 }}>
        <Radio.Group
          value={item.target_mode}
          disabled={is_loading_target_estimation}
          onChange={async ({
            nativeEvent: {
              target: { value },
            },
          }) => {
            set_templates(
              produce((draft) => {
                for (let e of draft) {
                  if (e.id == item.id) {
                    e.target_mode = value;
                  }
                }
                return draft;
              })
            );
            //
            //reset estimation
            set_target_estimation();
          }}
          optionType="button"
          buttonStyle="solid"
          size="large"
        >
          <Radio value="all_consumer">{t("pushNotification.text9")}</Radio>
          <Radio value="partial_consumer">{t("pushNotification.text59")}</Radio>
        </Radio.Group>
      </Row>
    );
  };

  const render_input_mode_radio_group = () => {
    return (
      <Row style={{ width: "100%", marginBottom: 25 }}>
        <Radio.Group
          onChange={({
            nativeEvent: {
              target: { value },
            },
          }) => {
            set_target_input_mode(value);
          }}
          value={target_input_mode}
        >
          <Radio value="xlsx">{t("pushNotification.text60")}</Radio>
          <Radio value="manual">{t("pushNotification.text57")}</Radio>
        </Radio.Group>
      </Row>
    );
  };

  const render_xlsx_upload_btn = () => {
    return (
      <Row style={{ width: "100%", marginBottom: 25 }}>
        <Upload {...upload_xlsx_props}>
          {/* <Button type="primary" style={{ marginBottom: 25 }} icon={<UploadOutlined />}>
            匯入xlsx
          </Button> */}
          <div>
            {<PlusOutlined />}
            <div style={{ marginTop: 10 }}>{t("pushNotification.text60")}</div>
          </div>
        </Upload>
        {is_xlsx_error ? <Row style={{ color: "red" }}>{t("pushNotification.text61")}</Row> : null}
      </Row>
    );
  };

  const render_import_count = () => {
    return (
      <Row
        justify="space-between"
        align="middle"
        style={{ width: "100%", border: "1px solid #DADADA", borderRadius: 5, padding: 10, marginBottom: 25 }}
      >
        <Col>
          {t("pushNotification.text62")}
          <span style={{ fontSize: 18, color: style.blue2, marginLeft: 10 }}>
            {active_template.targets?.length > 0 ? active_template.targets.length : 0}
          </span>
        </Col>
        <Col>
          <Button
            type="primary"
            disabled={active_template.targets?.length > 0 == false}
            onClick={() => {
              csvUtil.exportToCSV({
                fileName: "tel_list",
                csvData: active_template.targets.map((e) => {
                  return {
                    tel: e.replace("+1", ""),
                  };
                }),
              });
            }}
            icon={<DownloadOutlined />}
          >
            {t("pushNotification.text32")}
          </Button>
        </Col>
      </Row>
    );
  };

  const render_estimation = () => {
    return is_step_valid(2) ? (
      <Row
        justify="space-between"
        align="middle"
        style={{ width: "100%", border: "1px solid #DADADA", borderRadius: 5, padding: 10, marginBottom: 25 }}
      >
        <Col>
          估計可接收的使用者:
          <span style={{ fontSize: 18, marginLeft: 10, color: style.blue2 }}>
            {is_loading_target_estimation ? (
              <Spin size="small" />
            ) : target_estimation ? (
              <span>
                {target_estimation}
                <Tooltip
                  title={
                    active_template.target_mode == "all_consumer"
                      ? `預估值是依據 全體消費者 計算得出，這些使用者曾申請接收通知。`
                      : `預估值是依據約 ${active_template.targets.length} 名使用者計算得出，這些使用者曾申請接收通知。`
                  }
                >
                  <IonIcon icon={helpCircleOutline} style={{ marginLeft: 10, fontSize: 18, color: "black" }} />
                </Tooltip>
              </span>
            ) : (
              "--"
            )}
          </span>
        </Col>
        <Col>
          <Button
            type="primary"
            shape="round"
            disabled={is_loading_target_estimation}
            onClick={() => {
              //get_target_estimation();
            }}
          >
            預測
          </Button>
        </Col>
      </Row>
    ) : null;
  };

  const render_deep_link_panel = () => {
    return (
      <Panel header={t("pushNotification.text63")} key={3}>
        {/* {render_json_input(active_template)}
        {render_json_error_text()} */}
        <Row style={{ marginBottom: 25 }}>
          {t("pushNotification.text64")} Deep Link:
          <Switch
            style={{ marginLeft: 15 }}
            onChange={(checked) => {
              //console.log(checked);
              set_templates(
                produce((draft) => {
                  for (let e of draft) {
                    if (e.id == active_template_id) {
                      if (checked) {
                        //enable
                        e.data = { type: "shop_detail", url: "/home", vendorId: null };
                      } else {
                        //disable
                        e.data = null;
                      }
                    }
                  }
                  return draft;
                })
              );
            }}
            checked={active_template?.data != null}
          />
        </Row>
        {render_deep_link_options()}

        {active_template?.data?.type == "shop_detail" ? render_deeplink_vendor_search_bar() : null}

        {active_template?.data?.type == "ad" ? render_deeplink_ad_search_bar() : null}

        {active_template?.data?.type == "promotion_code" ? render_deeplink_promotion_code_search_bar() : null}

        {/* <Button
          type="primary"
          shape="round"
          disabled={is_step_valid(3) == false}
          onClick={() => {
            handle_step_change(4);
          }}
        >
          下一步
        </Button> */}
      </Panel>
    );
  };

  const render_deep_link_options = () => {
    return active_template?.data != null ? (
      <Row justify="space-evenly" style={{ width: "100%", marginBottom: 25 }}>
        {deep_link_options.length > 0
          ? deep_link_options.map((option, i) => (
              <Col
                key={i}
                span={6}
                style={
                  option?.type == "promotion_code" && codes.length == 0
                    ? { textAlign: "center", cursor: "not-allowed" }
                    : active_template.data?.type == option.type
                    ? { border: "2px solid " + style.blue2, textAlign: "center", cursor: "pointer" }
                    : { textAlign: "center", cursor: "pointer" }
                }
                onClick={() => {
                  //skip if is disabled option
                  if (option?.type == "promotion_code" && codes.length == 0) {
                    return;
                  }

                  //get data
                  let data = { type: option.type, url: option.url };
                  if (option.type == "shop_detail") {
                    data.vendorId = option.vendorId;
                  } else if (option.type == "ad") {
                    data.id = option.id;
                  } else if (option.type == "promotion_code") {
                    data.code = option.code;
                  }
                  //
                  set_templates(
                    produce((draft) => {
                      for (let e of draft) {
                        if (e.id == active_template_id) {
                          if (e.data?.type == data.type) {
                            //do nothing
                          } else {
                            //select another option
                            e.data = data;
                          }
                        }
                      }
                      return draft;
                    })
                  );
                }}
              >
                <img style={{ height: 250, margin: 10, border: "1px solid #B9BBB6" }} src={option.photo} />
                <div
                  style={{
                    width: "100%",
                    textAlign: "center",
                    fontWeight: "bolder",
                    color: active_template.data?.type == option.type ? "white" : "black",
                    background: active_template.data?.type == option.type ? style.blue2 : "white",
                  }}
                >
                  {render_deep_link_caption(option)}
                </div>
                {option?.type == "promotion_code" && codes.length == 0 ? (
                  <div
                    style={{
                      width: "100%",
                      textAlign: "center",
                      fontWeight: "bolder",
                      color: "red",
                    }}
                  >
                    {t("pushNotification.text65")}
                  </div>
                ) : null}
              </Col>
            ))
          : null}
      </Row>
    ) : null;
  };

  const render_json_input = (item) => {
    const read_data = () => {
      if (item.data == null) {
        return null;
      } else if (typeof item.data === "string") {
        return item.data;
      } else {
        return JSON.stringify(item.data);
      }
    };
    return (
      <Row style={{ width: "100%", fontSize: 16, marginBottom: 25 }}>
        <span style={{ fontWeight: "bold" }}>自訂資料 (json format)</span>
        <Input.TextArea
          style={{ width: "100%", fontSize: style.inputFontSize }}
          autoSize={{ minRows: 3 }}
          value={read_data()}
          onChange={(e) => {
            let value = e.target.value == "" ? null : e.target.value;
            //console.log(value);
            set_templates(
              produce((draft) => {
                for (let e of draft) {
                  if (e.id == active_template_id) {
                    e.data = value;
                  }
                }
                return draft;
              })
            );
          }}
        />
      </Row>
    );
  };

  const render_json_error_text = () => {
    let valid = true;
    if (active_template.data != null) {
      let parse_result = parse_json(active_template.data);
      if (parse_result.status == "Error") {
        valid = false;
      }
    }
    return valid ? null : <Row style={{ color: "red", marginBottom: 25 }}>deep link資料格式不正確</Row>;
  };

  const render_tel_manual_input_error_text = () => {
    let valid = true;
    if (active_template.targets != null) {
      let parse_result = parse_tel_manual_input(active_template.targets);
      console.log(parse_result);
      if (parse_result.status == "Error") {
        valid = false;
      }
    }
    return valid ? null : <Row style={{ color: "red" }}>{t("pushNotification.text66")}</Row>;
  };

  const render_other_panel = () => {
    return (
      <Panel header="其他選項 (選填)" key={4}>
        <Row style={{ width: "100%", marginBottom: 25 }}>所有欄位皆為選填欄位</Row>
        排定時間(coming)
      </Panel>
    );
  };

  const render_title = () => {
    return (
      <Row style={{ width: "100%" }}>
        <Col span={24}>
          <Row justify="space-between" style={{ width: "100%", marginBottom: 20 }}>
            <Col style={{ fontSize: 22, fontWeight: "bolder" }}>{t("pushNotification.text67")}</Col>
            <Col>
              <Button
                disabled={is_loading_templates || is_submitting}
                size="large"
                type="primary"
                style={{ borderRadius: 20, marginLeft: 20 }}
                onClick={() => {
                  //get data for search bar
                  get_vendors();
                  get_ads();
                  get_codes();
                  //add temp obj to ad list
                  let copy = deepcopy(templates);
                  let newId = uuidv4();
                  copy.push({ id: newId, target_mode: "all_consumer" });
                  set_templates(copy);
                  //open form
                  set_is_creating_new(true);
                  set_active_template_id(newId);
                }}
              >
                {t("pushNotification.text68")}
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    );
  };

  const render_tabPane = () => {
    return (
      <>
        <Tabs
          onChange={(key) => {
            set_active_tabPane(key);
          }}
          size="large"
          activeKey={active_tabPane}
        >
          <TabPane tab={t("pushNotification.text69")} key="template">
            {render_template_table()}
          </TabPane>

          <TabPane tab={t("pushNotification.text70")} key="log">
            {render_delivery_log_table()}
          </TabPane>
        </Tabs>
      </>
    );
  };

  const render_delivery_log_table = () => {
    return (
      <Table
        pagination={{ position: ["none", "bottomCenter"] }}
        dataSource={delivery_logs}
        columns={delivery_log_table_colums}
        rowKey="index"
        loading={is_loading_delivery_log || is_submitting}
      />
    );
  };

  const render_back_btn = () => {
    return (
      <Button
        size="large"
        shape="round"
        disabled={is_submitting}
        style={{ marginBottom: 25 }}
        onClick={() => {
          if (is_creating_new) {
            //remove temp obj from ad list
            let copy = deepcopy(templates);
            copy = copy.filter((e) => e.id != active_template_id);
            set_templates(copy);
            discard_form();
          } else {
            reset_form();
            discard_form();
          }
        }}
      >
        <Row align="middle">
          <IonIcon icon={chevronBackOutline} />
          {t("pushNotification.text71")}
        </Row>
      </Button>
    );
  };

  const render_save_btn = () => {
    return is_creating_new ? (
      <Button
        type="primary"
        shape="round"
        size="large"
        disabled={is_form_valid() == false || is_submitting}
        style={{ marginRight: 5 }}
        onClick={() => {
          create_template();
        }}
      >
        {t("pushNotification.text72")}
      </Button>
    ) : (
      <Button
        type="primary"
        shape="round"
        size="large"
        disabled={is_form_valid() == false || is_submitting}
        style={{ marginRight: 5 }}
        onClick={() => {
          update_template();
        }}
      >
        {t("pushNotification.text73")}
      </Button>
    );
  };

  const render_delete_btn = () => {
    return (
      <Button
        type="text"
        shape="round"
        size="large"
        onClick={() => {
          Modal.confirm({
            title: t("pushNotification.text74"),
            //content: "some messages...some messages...",
            onOk: () => {
              delete_template(active_template.id);
            },
          });
        }}
        style={{ textAlign: "center" }}
      >
        <IonIcon icon={trash} /> {t("pushNotification.text75")}
      </Button>
    );
  };

  const render_template_table = () => {
    return (
      <Table
        pagination={false}
        dataSource={templates}
        columns={template_table_colums}
        rowKey="index"
        loading={is_loading_templates || is_submitting}
      />
    );
  };

  const render_action_header = () => {
    return (
      <Row justify="space-between" style={{ width: "100%" }}>
        <Col>{render_back_btn()}</Col>
        <Col>
          {render_save_btn()}
          {render_delete_btn()}
        </Col>
      </Row>
    );
  };

  useEffect(() => {
    get_data();
  }, []);

  return (
    <>
      {render_photo_error_msg()}
      {render_test_message_modal()}
      {render_delivery_detail_modal()}
      <div style={{ minHeight: "100vh", width: "100%" }}>
        {active_template_id == null ? (
          <>
            {render_title()}
            {render_tabPane()}
          </>
        ) : (
          <Row style={{ marginLeft: "15%", marginRight: "15%" }}>
            <Row style={{ width: "100%" }}>
              {render_action_header()}
              {render_accordion()}
            </Row>
          </Row>
        )}
      </div>
      <div style={{ marginBottom: "10%" }}></div>
    </>
  );
};

export default PushNotification;
